module.exports = __webpack_public_path__ + "img/21.32e5cd6f.jpg";